import React from 'react';
import {
  PieChart, Pie, Tooltip, Cell,
} from 'recharts';
import PropTypes from 'prop-types';
import { colors, dMargin, valueFormatter } from './consts';

function formatter({ value }) {
  return valueFormatter(value);
}

function PiePlot({ data, size }) {
  return (
    <PieChart width={size.width} height={size.height} margin={dMargin}>
      <Tooltip formatter={valueFormatter} />
      <Pie
        dataKey={data.lines[0].name}
        fill={data.lines[0].color}
        nameKey={data.dataKey.key}
        data={data.items}
        cx="50%"
        cy="50%"
        outerRadius="80%"
        label={formatter}
      >
        {data.items.map((row, i) => (
        // eslint-disable-next-line react/no-array-index-key
          <Cell key={i} fill={colors[Math.min(i, colors.length - 1)]} />
        ))}
      </Pie>
    </PieChart>
  );
}

PiePlot.propTypes = {
  data: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})),
    dataKey: PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
    }),
    lines: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      name: PropTypes.string,
      color: PropTypes.string,
    })),
  }).isRequired,
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
};

export default PiePlot;
